// import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
// import { faMapMarkerAlt, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'; // Import solid icons
// import logo from '../img/logo/AA_LOGO.png';
// import { Link } from 'react-router-dom';

// const Footer = () => {
//   return (
//     <footer>
//       <div className="container-fluid">
//         <div className="row p-3-vh">
//           <div className="col-md-4">
//             <div className="logo d-flex align-items-center">
//               {/* <img alt="logo" src={logo} style={{ maxHeight: '78px' }} /> */}
//               <div className="ml-3 text-white"> {/* Added text-white class for white text */}
//                 <h1 className="m-0" style={{ fontFamily: 'Raqupine Regular' }}>TRANS2go</h1>
//                 <h1 className="m-0" style={{ fontFamily: 'Raqupine Regular' }}>LOGISTIC</h1>
//                 <p className="m-0"></p>
//               </div>
//             </div>
//             <div className="description">
//               "Driving Your Logistics Forward with Smart Solutions."
//             </div>
//             <div className="s-social">
//               {/* Social Icons */}
//               <a href="#"><span className="ti-facebook"></span></a>
//               <a href="#"><span className="ti-linkedin"></span></a>
//               <a href="#"><span className="ti-instagram"></span></a>
//               <a href="#"><span className="ti-youtube"></span></a>
//             </div>
//           </div>

//           <div className="col-md-3">
//             <div className="heading">Services</div>
//             <div className="s-address">
//               <div className="detail">

//                 <Link to="/web-mobile-applications">Warehousing </Link>
//               </div>
//               <div className="detail">

//                 <Link to="/it-services"> Road Transportaion</Link>
//               </div>
//               <div className="detail">


//                 <Link to="/gaming">Imports & Exports</Link>
//               </div>
//               {/* <div className="detail">
//                 <a href="/">Bus</a>
//               </div> */}

//             </div>
//           </div>

//           <div className="col-md-2">
//             <div className="heading">Quick Links</div>
//             <div className="s-address">
//               <div className="detail">
//                 <Link to="/">Home</Link>
//               </div>
//               <div className="detail">
//                 <Link to="/who-we-are">Who We Are</Link>
//               </div>
//               {/* <div className="detail">
//                 <Link to="/what-we-do">The Logistic</Link>
//               </div> */}
//               {/* <div className="detail">
//                 <Link to="/gellerypage">Gallery</Link>
//               </div> */}



//               {/* <div className="detail">
//                 <a href="gallery.php">Gallery</a>
//               </div> */}
//               <div className="detail">
//                 <Link to="/contact">Contact Us</Link>
//               </div>
//             </div>
//           </div>

//           <div className="col-md-3">
//             <div className="heading">Get In Touch</div>
//             <div className="s-address">
//               <div className="detail">
//                 <FontAwesomeIcon icon={faEnvelope} style={{ paddingRight: '10px' }} />
//                 contact@logistics.com
//               </div>
//               <div className="detail">
//                 <FontAwesomeIcon icon={faPhone} style={{ paddingRight: '10px' }} />
//                 (330) 474-9389
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row p-3-vh">
//           <div className="col-12">
//             <div className="subfooter">
//               <div className="copyright text-center">
//                 <p>Copyright©2024  <span style={{ fontFamily: 'Raqupine Regular', color: '#fff' }}> TRANS2go </span>, LLC. All Rights Reserved.</p>
//               </div>
//               <a className="terms" href="#">
//                 Terms of use | Privacy Environmental Policy.
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* WhatsApp Button */}
//       {/* <a href="https://wa.me/ (330) 474-9389" className="whatsapp-button" target="_blank" rel="noopener noreferrer">
//         <FontAwesomeIcon icon={faWhatsapp} className="fab fa-whatsapp" style={{ fontSize: "30px", color: "#fff" }} />
//       </a> */}
//     </footer>
//   );
// };

// export default Footer;





import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone,faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import logo from "../img/banner/S LOGO PNG-02-01.png";

const Footer = () => {
  return (
    <footer style={{ background: "rgb(0 18 35);", padding: "20px 0" }}>
      <div className="container-fluid">
        {/* Top Left Icons */}
        

        {/* Main Footer Content */}
        <div className="row p-2">
  {/* Quick Links */}
  <div className="col-md-3">
    <div className="heading" style={{color:"rgb(235, 195, 101)" ,fontWeight:'bold'}}>Quick Links</div>
    <div className="s-address" style={{fontFamily:'roboto',fontWeight:'bold'}}>
      <div className="detail"><a href="#who-we-are">Who We Are</a></div>
      <div className="detail">   <a href="#what-we-do">What We Do</a></div>
      <div className="detail"><a href="#contact">Contact</a></div>
      
    </div>
  </div>
 
  {/* Location Section */}
  
  {/* Get In Touch */}
  <div className="col-md-3">
    <div className="heading" style={{fontFamily:'lato sans ,serif',color:"rgb(235, 195, 101)", fontWeight:'bold',}}>Get In Touch</div>
    <div className="s-address">
      <div className="detail">
        <FontAwesomeIcon icon={faEnvelope} style={{ paddingRight: "10px" }} />
        info@sharansinn.com
      </div>
      {/* <div className="detail">
        <FontAwesomeIcon icon={faEnvelope} style={{ paddingRight: "10px" }} />
        sharaninn@.com
      </div> */}
      <div className="detail">
        <FontAwesomeIcon icon={faPhone} style={{ paddingRight: "10px" }} />
        9133555469
      </div>
    </div>
  </div>

  {/* <div className="col-md-3">
    <div className="heading" style={{fontFamily:'roboto',color:"rgb(235, 195, 101)"}}>Location</div>
    <div className="s-address">
      <div className="detail">
       
         <div style={{fontFamily:'roboto',}}>
        Sharan's Inn- Bongloor (Exit No 12, GNR Building, Gate, opp. to Petrol Pump, Bongloor, Hyderabad, Telangana 501510)

  
          <br />
          <strong>Office No.:</strong> 9133555469
        </div> 
      </div>
    </div>
  </div> */}
  <div className="row">
          <div className="col-md-12 d-flex justify-content-start align-items-center">
            <div className="s-social">
              <a href="#"><span className="ti-facebook"></span></a>
              <a href="#"><span className="ti-linkedin"></span></a>
              <a href="#"><span className="ti-instagram"></span></a>
              <a href="#"><span className="ti-youtube"></span></a>
            </div>
          </div>
        </div>
  </div>


        {/* Second Footer (Copyright + Logo) */}
        <div className="row p-2" style={{ borderTop: "1px solid #444", paddingTop: "10px",height:'95px' }}>
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div className="copyright text-white">
              
              <p>
              <img src={logo} alt="logo" style={{ height: "50px", width: "auto" }} />
                Copyright © 2025{" "}
                <span style={{ fontFamily: "Raqupine Regular", color: "rgb(235, 195, 101)" }}>
                  SHARAN`S INN`
                </span>
                , LLC. All Rights Reserved.

                
              </p>
            </div>
           
           
          </div>
        </div>
      </div>

    
      {/* <a href="https://wa.me/ (330) 474-9389" className="whatsapp-button" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: "30px", color: "#fff", position: "fixed", bottom: "30px", right: "20px" }} />
      </a> */}

      {/* Internal CSS */}
      <style>{`
        .s-social a {
          color: white;
          font-size: 18px;
          margin-right: 15px;
          transition: 0.3s;
        }
        .s-social a:hover {
          color: rgb(235, 195, 101);
        }
        .heading {
          font-weight: bold;
          font-size: 18px;
          color: white;
          margin-bottom: 10px;
        }
        .s-address .detail {
          color: white;
          margin-bottom: 8px;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
